import { useState, useEffect, useContext } from 'react'
import AuthContext from "../../contexte/AuthContext";
import { useTranslation } from 'react-i18next';
import './home.css'

// import all components
import DashboardLayout from "components/layout/dashboard/DashboardLayout";
import MainActions from 'components/DataComponents/MainActions/MainActions';
import KPI from 'components/DataComponents/KPI/KPI';

// import all services
import { fetchMainAction } from 'services/homeServices';
import ExanteAlert from 'components/DataComponents/ExanteAlert/ExanteAlert';
import { fetchExanteAvailable } from 'services/exanteServices';

const Home = () => {

    const { user } = useContext(AuthContext)
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true)

    // Declare all data States
    const [mainActionsData, setMainActionsData] = useState([])
    const [exanteAvailable, setExanteAvailable] = useState(0)


    useEffect(() => {
        const loadData = async () => {
            try {
                const mainActionsRequest = await fetchMainAction(user)
                setMainActionsData(mainActionsRequest)
            } catch (error) {
                setMainActionsData([-1, -1, -1, -1, -1])
            } finally {
                setLoading(false)
            }
        }

        const loadExanteAvailable = async () => {
            try {
                const available = await fetchExanteAvailable(user);
                console.log('available', available)
                setExanteAvailable(available)
            } catch (error) {
                setExanteAvailable(null)
            }
        }

        loadData();
        loadExanteAvailable()
    }, [user])

    return (
        <DashboardLayout page={t('pages_name.accueil')}>
            <div className='home_layout'>
                {!loading ? (
                    <div className='home_layout_left'>
                        <MainActions mainActionsData={mainActionsData} />
                        <hr />
                        <ExanteAlert available={exanteAvailable} />
                        <KPI />
                    </div>
                ) : (
                    <div>loading...</div>
                )
                }
            </div>
        </DashboardLayout>


    )
}

export default Home